<style scoped>
    .fin-expense-type{
        position: relative;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        margin: 2px 0;
        transition: .4s;
    }
    .fin-expense-type:hover{
        /*background: #e5e5e5;*/
        border-color: #2b85e4;
    }
    .fin-expense-type-btn{
        float: right;
        cursor: pointer;
    }
    .fin-expense-type-btn:hover{
        font-weight: bold;
    }
    /*.fin-expense-type-2{*/
        /*padding-left: 14px;*/
    /*}*/
    /*.fin-expense-type-3{*/
        /*padding-left: 22px;*/
    /*}*/
    .color-dot{
        display: inline-block;
        vertical-align: middle;
        width: 10px;
        height: 10px;
    }
    .color-block{

    }
</style>
<template>
    <div>
        <div class="fin-expense-type"
             :class="[`fin-expense-type-${fin_expense_type.level}`]"
             :key="fin_expense_type.id">
            <span class="color-dot" :class="'row-' + fin_expense_type.bg_color" v-if="fin_expense_type.bg_color"></span>
            <span>{{fin_expense_type.name}}</span>
            <span>({{fin_expense_type.id}})</span>
            <span class="color-info" v-if="fin_expense_type.sum_ids">(+{{fin_expense_type.sum_ids}})</span>
            <span class="color-warning" v-if="fin_expense_type.sub_ids">(-{{fin_expense_type.sub_ids}})</span>
            <span class="color-info" v-if="fin_expense_type.share_type">(分摊)</span>
            <span class="color-error" v-if="fin_expense_type.is_manual">(手工)</span>
            <span class="fin-expense-type-btn" @click="editFinExpenseType(fin_expense_type)">编辑</span>
            <template v-if="fin_expense_type.fin_expense_types.length">
                <FinExpenseTypeEdit
                        @edit="editFinExpenseType"
                        :fin_expense_type="expense_type"
                        v-for="expense_type in fin_expense_type.fin_expense_types"
                        :key="expense_type.id">
                </FinExpenseTypeEdit>
            </template>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: ['fin_expense_type'],
        data () {
            return {
                //
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            editFinExpenseType(expense_type){
                this.$emit('edit', expense_type);
            },
            isHlExpenseType(expense_type){
                return this.hl_expense_type_ids.indexOf(expense_type.id) > -1;
            },
            isHlSumType(expense_type){
                return this.hl_sum_ids.indexOf(expense_type.id) > -1;
            },
        }
    }
</script>
